import { differenceInMinutes, parse, startOfDay } from 'date-fns'
import { isEmpty } from 'ramda'

import { LIVE_EVENT_STATUS } from '../../../../../common/constants'

const createEmptyFormModel = (timezones, accountInfoId) => {
    const timezone = timezones.find(({ is_active: isActive }) => isActive) || {}

    return {
        name: '',
        image: undefined,
        description: '',
        date: undefined,
        fromTime: undefined,
        toTime: undefined,
        timezoneId: timezone.id,
        globalTagsIds: [],
        isPromote: false,
        isGroupPromote: false,
        internalSpeakerIds: [accountInfoId],
        externalSpeakerEmails: [
            {
                email: '',
                confirmEmail: '',
            },
        ],
        ambassadorIds: [],
        speakersPlaceholder: '',
    }
}

const createEditFormModel = (data) => {
    if (data.status === LIVE_EVENT_STATUS.IN_PROGRESS) {
        return {
            name: data.name,
            description: data.description,
            globalTagsIds: data.globalTags,
        }
    }

    const fromDate = parse(data.fromDate, "yyyy-MM-dd'T'HH:mm:ss'.000Z'", new Date())
    const toDate = parse(data.toDate, "yyyy-MM-dd'T'HH:mm:ss'.000Z'", new Date())

    const fromTime = differenceInMinutes(fromDate, startOfDay(fromDate))
    const toTime = differenceInMinutes(toDate, fromDate) + fromTime

    return {
        id: data.id,
        name: data.name,
        image: data.image.original,
        description: data.description,
        timezoneId: data.timezoneId,
        globalTagsIds: data.globalTags,
        isPromote: !data.isPromote,
        isGroupPromote: !data.isGroupPromote,
        date: fromDate,
        fromTime,
        toTime,
    }
}

export default (data = {}, timezones, accountInfoId) =>
    isEmpty(data) ? createEmptyFormModel(timezones, accountInfoId) : createEditFormModel(data)
